import { IProgramsListContext, ProgramsListContext } from '../../../../../../application/context/Programs/ProgramsList/ProgramsListContext';
import React, { useContext } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import qs from "qs";

export default function Pagination() {
    const { state } = useContext<IProgramsListContext>(ProgramsListContext);
    const { data: programs, limit } = state.getProgramsState;

    const location = useLocation();
    const params = useParams<any>();

    const searchQuery = qs.parse(location.search, { ignoreQueryPrefix: true }).search_query;

    const page = parseInt(params.programsPage);

    const nextPageIndex = page === 1 && programs.length === limit ? 1 : 2;

    return (
        <div className="d-flex align-items-center">
            {page > 1 && programs.length > 0 && (
                <>
                <div className="w-100">
                    <Link
                    to={`/admin/dashboard/settings/programs/page/${page - 1}/?prev_page=${programs[0].programId}&search_query=${searchQuery ?? ""}`}
                    >
                        <svg className="icon icon-dark" height="20" viewBox="0 0 24 24" width="20"><path d="M0 0h24v24H0z" fill="none"/><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                    </Link>
                </div>
                <span className="text-dark-third pl-2 pr-2">{page - 1}</span>
                </>
            )}

            <span className="btn bg-dark-third btn-rounded text-white">{page}</span>

            {programs.length === limit + 1 || (page === 1 && programs.length === limit) ? (
                <>
                <span className="text-dark-third pl-2 pr-2">{page + 1}</span>
                <div className="text-right w-100">
                    <Link
                    to={`/admin/dashboard/settings/programs/page/${page + 1}/?next_page=${programs[programs.length - nextPageIndex].programId}&search_query=${searchQuery ?? ""}`}
                    >
                        <svg className="icon icon-dark" height="20" viewBox="0 0 24 24" width="20"><path d="M0 0h24v24H0z" fill="none"/><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                    </Link>
                </div>
                </>
            ) : ("")}
        </div>
    )
}
